// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CopyIcon.css */
.copy-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px; /* small gap between text and icon */
  height: 100%; /* ensures it aligns perfectly in table rows */
}

.copy-icon-wrapper svg {
  vertical-align: middle;
}
/* Parent cell container */
.copy-cell {
  position: relative;
  padding-right: 22px; /* Add space for icon so text doesn’t overlap */
  text-align: left;
}

/* Icon positioning */
.copy-icon-wrapper {
  position: absolute;
  top: -10px; /* Adjust this to control vertical alignment */
  right: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Optional: smaller icon size consistency */
.copy-icon-wrapper svg {
  width: 13px;
  height: 13px;
  vertical-align: middle;
  opacity: 0.8;
  transition: opacity 0.2s ease-in-out;
}

.copy-icon-wrapper:hover svg {
  opacity: 1;
}

/* Truncated text styling */
.truncate-cell {
  display: block;
  max-width: 100px; /* Adjust as needed */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/components/CopyIcon/CopyIcon.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB,EAAE,oCAAoC;EACtD,YAAY,EAAE,8CAA8C;AAC9D;;AAEA;EACE,sBAAsB;AACxB;AACA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,mBAAmB,EAAE,+CAA+C;EACpE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,UAAU,EAAE,8CAA8C;EAC1D,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,gBAAgB,EAAE,qBAAqB;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":["/* CopyIcon.css */\n.copy-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 6px; /* small gap between text and icon */\n  height: 100%; /* ensures it aligns perfectly in table rows */\n}\n\n.copy-icon-wrapper svg {\n  vertical-align: middle;\n}\n/* Parent cell container */\n.copy-cell {\n  position: relative;\n  padding-right: 22px; /* Add space for icon so text doesn’t overlap */\n  text-align: left;\n}\n\n/* Icon positioning */\n.copy-icon-wrapper {\n  position: absolute;\n  top: -10px; /* Adjust this to control vertical alignment */\n  right: 2px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Optional: smaller icon size consistency */\n.copy-icon-wrapper svg {\n  width: 13px;\n  height: 13px;\n  vertical-align: middle;\n  opacity: 0.8;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.copy-icon-wrapper:hover svg {\n  opacity: 1;\n}\n\n/* Truncated text styling */\n.truncate-cell {\n  display: block;\n  max-width: 100px; /* Adjust as needed */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
